module.exports = __webpack_public_path__ + "img/staff.08be55e7.svg";